import { useMutation } from "@apollo/client";

import type {
  AddProductMutation,
  AddProductMutationVariables,
} from "../../../API";
import { ADD_PRODUCT } from "../../../common/operations/mutations";
import { handleApolloError } from "../../../common/utils/handleApolloError";

export const useAddProduct = () => {
  const [addProductMutation, { loading }] = useMutation<
    AddProductMutation,
    AddProductMutationVariables
  >(ADD_PRODUCT, { onError: handleApolloError });

  const addProduct = (input: AddProductMutationVariables["input"]) =>
    addProductMutation({ variables: { input } });

  return { addProduct, loading };
};
